import React from 'react';
import { Pencil } from 'lucide-react';

const InfoRow = ({ label, value }) => (
  <div className="flex items-start py-4 border-b border-slate-100 last:border-0">
    <span className="w-32 text-slate-500 text-[14px] font-medium">{label}</span>
    <span className="w-4 text-slate-500 text-[14px]">:</span>
    <span className="flex-1 text-[#1e3a8a] font-medium text-[14px]">{value}</span>
  </div>
);

export default function ProductInfoLain({ product, onEdit }) {
  if (!product) return null;

  return (
    <div className="bg-white rounded-xl shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] border border-slate-100 p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-[#1e3a8a] text-[18px] font-bold">Informasi Lain</h3>
        <button 
          onClick={onEdit}
          className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-[#1e3a8a] rounded-lg hover:bg-slate-50 font-medium text-sm transition-colors shadow-sm"
        >
          <Pencil className="w-3.5 h-3.5" /> Ubah
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12">
        {/* Kolom Kiri: Supplier & Minimum Stok */}
        <div className="flex flex-col">
          <InfoRow label="Supplier" value={product.supplier || "-"} />
          <InfoRow label="Minimum Stok" value={product.min_stock ? `${product.min_stock} Pcs` : "-"} />

          {/* HIDDEN: Berat Produk & Dimensi
          <InfoRow label="Berat Produk" value={product.weight ? `${product.weight} Gram` : "-"} />
          <InfoRow label="Dimensi" value={product.dimensions || "-"} />
          */}
        </div>

        {/* Kolom Kanan: Lokasi Stok & Deskripsi */}
        <div className="flex flex-col">
          <InfoRow label="Lokasi Stok" value={product.stock_location_name || product.location_name || product.rack_location || "-"} />
          <InfoRow label="Deskripsi" value={product.notes || product.description || "-"} />

          {/* HIDDEN: Bahan, Garansi, & Tag
          <InfoRow label="Bahan" value={product.material || "-"} />
          <InfoRow label="Garansi" value={product.warranty_months ? `${product.warranty_months} Bulan` : "-"} />
          <div className="flex items-start py-4 border-b border-slate-100 last:border-0">
            <span className="w-32 text-slate-500 text-[14px] font-medium">Tag</span>
            <span className="w-4 text-slate-500 text-[14px]">:</span>
            <span className="flex-1 flex flex-wrap gap-2 mt-[-4px]">
              {product.tags && product.tags.length > 0 ? (
                (Array.isArray(product.tags) ? product.tags : product.tags.split(',')).map(t => (
                  <span key={t} className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">{t.trim()}</span>
                ))
              ) : "-"}
            </span>
          </div>
          */}
        </div>
      </div>
    </div>
  );
}
